module.exports = __webpack_public_path__ + "static/media/auth.1ee45158.jpg";